export const IMAGES_PATH = '/assets/images/';
export const COUNTRY_ICONS_PATH = `${IMAGES_PATH}country/`;
export const COUNTRY_ICONS = {
    AR: `${COUNTRY_ICONS_PATH}ar.png`,
    EN: `${COUNTRY_ICONS_PATH}en.png`,
    ES: `${COUNTRY_ICONS_PATH}sp.png`,
    FR: `${COUNTRY_ICONS_PATH}fr.png`,
    HE: `${COUNTRY_ICONS_PATH}he.png`,
    PT: `${COUNTRY_ICONS_PATH}pt.png`,
};
export const APP_LOGO_BLUE_PATH = `${IMAGES_PATH}app-logo-blue.svg`;
export const APP_LOGO_BLUE_NY_PATH = `${IMAGES_PATH}app-logo-blue-ny.svg`;
export const SALESFORCE_INTEGRATION_LOGO_PATH = `${IMAGES_PATH}integrations/salesforce.svg`;
export const IOS_INTEGRATION_LOGO_PATH = `${IMAGES_PATH}integrations/ios.svg`;
export const ANDROID_INTEGRATION_LOGO_PATH = `${IMAGES_PATH}integrations/android.svg`;
export const APPOINTMENTS_APPLICATION_INTEGRATION_LOGO_PATH = `${IMAGES_PATH}integrations/calendar.svg`;
export const INTEGRATION_NO_LOGO_PATH = `${IMAGES_PATH}integrations/no-logo.svg`;
export const LOGO_ICON_PATH = `${IMAGES_PATH}logo-icon.svg`;
export const ACCOUNT_PLAN_BANNER_PATH = `${IMAGES_PATH}background-banner-person.svg`;
export const ACCOUNT_ACTIVATION_WELCOME_PATH = `${IMAGES_PATH}activation-welcome.svg`;
export const COLORED_AGENT_LOGO_PATH = `${IMAGES_PATH}colored-agent-logo.png`;
export const DESKTOP_PAYMENT_SUCCESS_BANNER_PATH = `${IMAGES_PATH}payment-success-desktop.png`;
export const MOBILE_PAYMENT_SUCCESS_BANNER_PATH = `${IMAGES_PATH}payment-success-mobile.png`;
export const ACCOUNT_BLOCKED = `${IMAGES_PATH}account-blocked.svg`;
export const PAYMENT_SOURCE_ADDED = `${IMAGES_PATH}payment-source-added.svg`;
export const NO_TEXT_CHAT_HISTORY = `${IMAGES_PATH}no-text-chat-history.svg`;
export const TEXT_CHAT_HISTORY_ERROR = `${IMAGES_PATH}text-chat-history-error.svg`;
export const BLUE_AGENT_LOGO_PATH = `${IMAGES_PATH}blue-agent-logo.png`;
export const PASSWORD_CHANGE = `${IMAGES_PATH}password-change.svg`;
export const AVATAR_BG_PATH = `${IMAGES_PATH}avatar-office-portrait-v2.png`;
